Vue.component('admin-users', {
  props: ['role'],

  data () {
    return {
      users: null,
      user: null,
    };
  },

  /**
   * The component has been created by Vue.
   */
  created () {
    this.getUsers();

    this.$on('getUser', function (id) {
      this.getUser(id);
    });

    this.$on('deleteUser', function () {
      this.user = null;
    });

    this.$on('updateUsers', function () {
      this.getUsers();
    });

    this.$on('showCreateUserModal', function () {
      this.showCreateUserModal();
    });

    this.$on('showEditUserModal', function () {
      this.showEditUserModal();
    });

    this.$on('showDeleteUserModal', function () {
      this.showDeleteUserModal();
    });
  },

  methods: {
    /**
     * Get the specified User.
     */
    getUser (id) {
      axios.get('/api/users/' + id)
        .then(response => {
          this.user = response.data.user;
        });
    },

    /**
     * Get the Users.
     */
    getUsers () {
      let self = this;

      axios.get('/api/users?role=' + this.role)
        .then(function (response) {
          self.users = response.data.users;

          if (self.user === null && self.users.length > 0) {
            self.getUser(self.users[0].id);
          }
        });
    },

    showCreateUserModal () {
      $('#modal-create-user').modal('show');
    },

    showEditUserModal () {
      $('#modal-update-user').modal('show');
    },

    showDeleteUserModal () {
      $('#modal-delete-user').modal('show');
    },
  }
});
